// Base url code | POSSIBLE VALUES 'dev', 'stg', ''
export const VUE_APP_URL_ENV_CODE = process.env.VUE_APP_URL_ENV_CODE

// Used for url like https://gateway-dev.farmapremium.es | POSSIBLE VALUES: '-dev', '-stg', ''
export const URL_ENV_CODE = VUE_APP_URL_ENV_CODE ? `-${VUE_APP_URL_ENV_CODE}` : ''

// Used for subdomain like: https://dev.farmapremium.es  | POSSIBLE VALUES: 'dev.', 'stg.', ''
export const URL_ENV_CODE_ROOT_DOMAIN = VUE_APP_URL_ENV_CODE ? `${VUE_APP_URL_ENV_CODE}.` : ''

// User for projects tag :VALUES: 'dev', 'stg', 'prod'
export const TAG_ENV_CODE = process.env.VUE_APP_TAG_ENV_CODE

export const FARMACLOUD_URL_ENV_CODE = process.env.VUE_APP_FARMACLOUD_URL_ENV_CODE
